module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    staticClass: "page-view-index"
  }, [_c('div', [_c('slide-bar', {
    attrs: {
      "show": _vm.drawerShow,
      "pos": _vm.pos,
      "tran": _vm.tran
    },
    on: {
      "change-show": _vm.changeDrawerShow,
      "on-hide": _vm.onHide,
      "on-show": _vm.onShow
    }
  }, [_c('div', {
    staticClass: "userInfo",
    attrs: {
      "slot": "drawer"
    },
    slot: "drawer"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../assets/img/enterprise/43_default_avatar.png")
    },
    on: {
      "click": _vm.login
    }
  }), _vm._v(" "), (_vm.user_phone) ? _c('p', {
    staticClass: "user_phone"
  }, [_vm._v(_vm._s(_vm.user_phone))]) : _vm._e(), _vm._v(" "), (_vm.user_phone) ? _c('p', {
    staticClass: "logout",
    on: {
      "click": _vm.isLogout
    }
  }, [_c('span', [_vm._v("退出登录")])]) : _vm._e(), _vm._v(" "), (!_vm.user_phone) ? _c('p', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.login
    }
  }, [_c('span', [_vm._v("点击登录")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "mainNav"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/myOrder')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_order"
  }), _vm._v("我的订单\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/collectLine')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_collect"
  }), _vm._v("我的收藏\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/feedbackEnt')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_custom"
  }), _vm._v("线路反馈\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/myMessage')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_message"
  }), _vm._v(" "), _c('span', {
    staticClass: "new_message_tips"
  }, [_vm._v("\n              我的消息\n              "), (_vm.new_message) ? _c('b') : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/feedback')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_help"
  }), _vm._v("意见反馈\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jumpPage('/checkedRecord')
      }
    }
  }, [_c('i', {
    staticClass: "icon_nav_checked_record"
  }), _vm._v("验票记录\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.linkVersion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon_back_version"
  }), _vm._v("返回旧版\n          ")])]), _vm._v(" "), _c('footer', {
    staticClass: "slider_bottom",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('div', {
    staticClass: "serive_phone"
  }, [(_vm.sever_phone) ? _c('span', [_vm._v("客服电话：")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.sever_phone
    },
    on: {
      "click": _vm.markClick
    }
  }, [_vm._v(_vm._s(_vm.sever_phone))])]), _vm._v(" "), _c('span', {
    staticClass: "select_city",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_c('i', {
    staticClass: "icon_location"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.current_city || '无定位'))])])])])])], 1), _vm._v(" "), ((_vm.show_select_dialog == 2 || (!_vm.cacheCity && _vm.show_select_dialog == 1) || !_vm.current_city) && _vm.is_loaded_location) ? _c('div', {
    staticClass: "select_city_dialog"
  }, [_c('div', {
    staticClass: "dialog_content"
  }, [(_vm.show_select_dialog == 2) ? _c('p', [_vm._v("哇呜，当前城市未开通班车哦")]) : _c('p', [_vm._v("哇呜，暂时定位不到当前城市")]), _vm._v(" "), (_vm.show_select_dialog == 2) ? _c('a', {
    staticClass: "redBtn",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_vm._v("切换到其他城市")]) : _c('a', {
    staticClass: "redBtn",
    on: {
      "click": function($event) {
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_vm._v("手动选择城市")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "0",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "scene_nav_box"
  }, [_c('div', {
    staticClass: "usercenter_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeDrawerShow(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-user-center-btn opt_icon_user"
  }), _vm._v(" "), (_vm.new_message) ? _c('b', {
    staticClass: "new_message"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-city",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpPage('/selectCity')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.current_city || '无定位'))]), _vm._v(" "), _c('span', {
    staticClass: "icon opt_icon_arrow"
  })])]), _vm._v(" "), (_vm.view_type === 'address') ? _c('notice', {
    attrs: {
      "position": "1"
    },
    on: {
      "noticed": _vm.showNotice
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "view-commuter"
  }, [(_vm.view_type === 'address') ? _c('commute-address', {
    attrs: {
      "show_notice": _vm.is_show_notice
    }
  }) : _vm._e(), _vm._v(" "), (_vm.view_type === 'code') ? _c('commute-code') : _vm._e()], 1), _vm._v(" "), (_vm.last_feedback_message) ? [_c('div', {
    staticClass: "view-feedback-message",
    class: _vm.show_last_feedback_message ? 'active' : ''
  }, [_c('div', {
    staticClass: "feedback-message",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toFeedbackDetail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "message-tips"
  }, [_c('span', {
    staticClass: "message-tips-title"
  }, [_vm._v(_vm._s(_vm.last_feedback_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.last_feedback_message))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-message-control"
  }, [_vm._v("查看")])])])] : _vm._e()], 2), _vm._v(" "), _c('confirm', {
    attrs: {
      "is_show": _vm.show_logout_dialog,
      "title": "确定要退出登录吗？",
      "is_logout": true,
      "phone": _vm.user_real_phone,
      "leftContent": "再想想",
      "rightContent": "确认"
    },
    on: {
      "confirm": _vm.logout,
      "cancel": function($event) {
        _vm.show_logout_dialog = !_vm.show_logout_dialog
      }
    }
  }), _vm._v(" "), _c('confirm', {
    attrs: {
      "is_show": (!!_vm.location_dialog_type && _vm.is_loaded_location),
      "title": "",
      "is_logout": false,
      "phone": true,
      "leftContent": "否",
      "rightContent": "是"
    },
    on: {
      "confirm": function($event) {
        return _vm.jumpPage('/selectCity')
      },
      "cancel": _vm.setCacheCity
    }
  }, [_c('div', {
    staticClass: "confirm_content_text"
  }, [_vm._v("您的定位功能未打开，目前所定位城市为" + _vm._s(_vm.cacheCity) + "，是否手动定位城市？")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec18ada","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Index.vue
// module id = 505
// module chunks = 39